<template>
    <BModal ref="createInterventionModal" :title="$t('interventions.modal.createTitle')" centered no-close-on-backdrop header-variant="primary" modal-class="no-border-modal">
        <form v-if="intervention" class="modal-content" id="createInterventionForm" @submit.prevent="handleSubmit">
            <div class="mb-3">
                <label class="form-label">{{ $t('interventions.modal.installation') }}</label>
                <select class="form-select" v-model="intervention.facility_id" required>
                    <option value="" disabled>{{ $t('interventions.modal.selectInstallation') }}</option>
                    <option v-for="facility in facilities" :key="facility.id" :value="facility.id">{{ facility.name }}</option>
                </select>
            </div>
            <div class="mb-3">
                <label class="form-label">{{ $t('interventions.modal.installerEmail') }}</label>
                <input class="form-control" type="email" required placeholder="email@exemple.com" v-model="intervention.email">
            </div>
            <div class="mb-3">
                <label class="form-label">{{ $t('interventions.modal.validityStart') }}</label>
                <VueDatePicker
                    v-model="intervention.validity_start"
                    :locale="$i18n.locale"
                    :enable-time-picker="true"
                    format="dd/MM/yyyy HH:mm"
                    :placeholder="$t('interventions.modal.datePlaceholder')"
                    :select-text="$t('interventions.modal.datePickerSelect')"
                    :cancel-text="$t('interventions.modal.datePickerCancel')"
                    required
                />
            </div>
            <div class="mb-3">
                <label class="form-label">{{ $t('interventions.modal.validityEnd') }}</label>
                <VueDatePicker
                    v-model="intervention.validity_end"
                    :locale="$i18n.locale"
                    :enable-time-picker="true"
                    format="dd/MM/yyyy HH:mm"
                    :placeholder="$t('interventions.modal.datePlaceholder')"
                    :select-text="$t('interventions.modal.datePickerSelect')"
                    :cancel-text="$t('interventions.modal.datePickerCancel')"
                    required
                />
            </div>
            <div class="mb-3">
                <label class="form-label">{{ $t('interventions.modal.note') }} <span class="text-muted">{{ $t('interventions.modal.optional') }}</span></label>
                <textarea class="form-control" v-model="intervention.note" rows="2" :placeholder="$t('interventions.modal.notePlaceholder')"></textarea>
            </div>
        </form>
        <template #footer="{ cancel }">
            <div class="d-flex justify-content-between align-items-center w-100">
                <button type="button" class="btn btn-secondary" @click="cancel">{{ $t('interventions.modal.cancel') }}</button>
                <span v-if="errorMessage" class="flex-grow-1 mx-3 text-center custom-error-msg">{{ errorMessage }}</span>
                <button type="submit" class="btn btn-primary" form="createInterventionForm">{{ $t('interventions.modal.create') }}</button>
            </div>
        </template>
    </BModal>
</template>

<script>
import { useUserStore } from '@/stores/userStore';
import { useI18n } from 'vue-i18n';
import { showToast } from '@/services/toast';
import { BModal } from 'bootstrap-vue-next';
import { ref } from 'vue';
import Intervention from '@/models/intervention';

export default {
    name: 'CreateInterventionModal',
    components: {
        BModal,
    },
    emits: ['created'],
    setup(props, { emit }) {
        const { t } = useI18n();
        const userStore = useUserStore();
        const createInterventionModal = ref(null);
        const errorMessage = ref('');
        const intervention = ref(null);
        const facilities = ref(userStore.facilities);

        const show = () => {
            intervention.value = new Intervention();
            errorMessage.value = '';
            createInterventionModal.value.show();
        };

        const hide = () => {
            createInterventionModal.value.hide();
        };

        const handleSubmit = async () => {
            try {
                const inter = await userStore.createIntervention(intervention.value);
                hide();
                showToast('success', t('interventions.modal.created'));
                emit('created', inter);
            } catch (error) {
                errorMessage.value = error;
            }
        };

        return {
            handleSubmit,
            errorMessage,
            createInterventionModal,
            intervention,
            facilities,
            show,
            hide,
        };
    },
};
</script>

<style>
.no-border-modal .modal-header {
  border-bottom: none !important;
}

.no-border-modal .modal-footer {
  border-top: none !important;
}
</style>
